import React from 'react';
import { Layout } from 'layout/layout';
import { Route, Switch } from 'react-router-dom';
import StaticPage from 'pages/authentication/staticPage/StaticPage';

const AppRouter = () => (
  <Switch>
    <Route exact path={["/login", "forgotPassword", "resetPassword", "/register","/paymentSearch","/userAdmin","/systemAdmin"]}>
      <Layout>
        <StaticPage/>
      </Layout>
    </Route>
  </Switch>
);

export default AppRouter;
